module.exports = {
  methods:
    contactsEmpty: ->
      jQuery.isEmptyObject @contacts

    updateContactRecipient: (data) ->
      if data.attr.id
        @contact_resource.updateRecipient @updateContactSuccess, @unknownError, data.attr
      else
        @contact_resource.update @updateContactSuccess, @unknownError, { id: data.attr.contact_id, status: data.attr.status }

    updateContact: (data) ->
      @contact_resource.update @updateContactSuccess, @unknownError, data.attr

    reengage: (data) ->
      @contact_resource.reengage @updateContactSuccess, @unknownError, data.attr

    resetContactRecipient: (data) ->
      attr = {}
      attr.contact_id = data.id
      attr.id = data.recipient.id
      @contact_resource.resetRecipient(@updateContactSuccess, @unknownError, attr)

    updateContactSuccess: (resources) ->
      @updateContactList resources.contact
      alertify.success 'Contato atualizado com sucesso!'

    updateContactList: (contact) ->
      EventsBus.$emit 'Show::UpdateContactsInfo', @flow if @flow
      if @contacts
        index = @contacts.findIndex contact.id

        if index > -1
          Vue.set @contacts, index, contact
        else
          @contacts.push contact
      else
        EventsBus.$emit 'Show::UpdateListContactsInfo', contact if contact

    updateContactResponsible: (contacts, user, contacts_ids) ->
      screenContacts = @_screenContacts(contacts, contacts_ids)
      for contact in screenContacts
        contact.user  = user
        contact.recipient_status = 'disqualified'
        contact.human_recipient_status = 'Desqualificado'

    updateContactTag: (contacts, contact_ids, change_tags) ->
      screenContacts = @_screenContacts(contacts, contact_ids)
      add_tag_ids    = @_add_tag_ids(change_tags)
      del_tag_ids    = @_del_tag_ids(change_tags)

      for contact in screenContacts
        add_tag_ids.forEach (tag_id) => @_add_tag(contact, tag_id, change_tags)
        del_tag_ids.forEach (tag_id) => @_del_tag(contact, tag_id)

    refreshContact: (params) ->
      @contact_resource.get @refreshContactSuccess, @unknownError, params

    refreshContactSuccess: (resources) ->
      @updateContactList resources.contact

    excludeContactFromList: (contact_id) ->
      index = @contacts.findIndex contact_id
      @contacts.splice index, 1 if index > -1

    destroyContact: (data) ->
      @contact_resource.destroy @destroyContactSuccessClosure(data.contact), @unknownError, id: data.contact.id

    destroyContactSuccessClosure: (contact) ->
      (response) =>
        @destroyContactSuccess contact, response

    openRecipientScheduleReactivationModal: (data) ->
      @schedule_reactivation_contact = data.attr.contact
      jQuery('#recipient-schedule-reactivation').modal('show')

    destroyContactSuccess: (contact, response) ->
      @excludeContactFromList contact.id
      alertify.success 'Contato removido com sucesso!'

    removeContactFromFlow: (contact, flow) ->
      @contact_resource.removeFromFlow(
        @removeContactFromFlowSuccessClosure(contact), @unknownError,
        id: contact.id, flow_id: flow.id
      )

    removeContactFromFlowSuccessClosure: (contact) ->
      (response) =>
        if @contacts
          @excludeContactFromList contact.id
          alertify.success 'Contato removido com sucesso!'

    # private

    _add_tag: (contact, tag_id, change_tags) ->
      idx = contact.tags.findIndexByProps(id: tag_id)

      if idx == -1
        tag = change_tags.find (tag) -> tag.id == tag_id
        contact.tags.push(new Tag(tag))

    _del_tag: (contact, tag_id) ->
      idx = contact.tags.findIndexByProps(id: tag_id)

      if idx > -1
        contact.tags.splice(idx, 1)

    _screenContacts: (contacts, contact_ids) ->
      contact for contact in contacts when contact.id in contact_ids

    _add_tag_ids: (change_tags) ->
      tag.id for tag in change_tags when tag.behavior == 'check'

    _del_tag_ids: (change_tags) ->
      tag.id for tag in change_tags when tag.behavior == 'uncheck'

}



// WEBPACK FOOTER //
// ./src/helpers/contacts/list_wrapper.coffee